










import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import BaseCheckbox from "@/components/BaseCheckbox/BaseCheckbox.vue";

@Component({ name: "TagItem", components: { BaseCheckbox } })
export default class TagItem extends Vue {
  @Prop({ required: true })
  public readonly tagInfo!: TagInfo;

  @Prop({ required: true })
  public readonly value!: boolean;
}
